/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardRepresentation
 */
export interface DashboardRepresentation {
    /**
     * 
     * @type {string}
     * @memberof DashboardRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRepresentation
     */
    portfolioKey: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardRepresentation
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardRepresentation
     */
    updated: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardRepresentation
     */
    widgetCount: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardRepresentation
     */
    order: number;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardRepresentation
     */
    automaticReportingActive?: boolean;
}

/**
 * Check if a given object implements the DashboardRepresentation interface.
 */
export function instanceOfDashboardRepresentation(value: object): value is DashboardRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('widgetCount' in value) || value['widgetCount'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function DashboardRepresentationFromJSON(json: any): DashboardRepresentation {
    return DashboardRepresentationFromJSONTyped(json, false);
}

export function DashboardRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'portfolioKey': json['portfolioKey'],
        'created': json['created'],
        'updated': json['updated'],
        'widgetCount': json['widgetCount'],
        'order': json['order'],
        'automaticReportingActive': json['automaticReportingActive'] == null ? undefined : json['automaticReportingActive'],
    };
}

export function DashboardRepresentationToJSON(json: any): DashboardRepresentation {
    return DashboardRepresentationToJSONTyped(json, false);
}

export function DashboardRepresentationToJSONTyped(value?: DashboardRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'portfolioKey': value['portfolioKey'],
        'created': value['created'],
        'updated': value['updated'],
        'widgetCount': value['widgetCount'],
        'order': value['order'],
        'automaticReportingActive': value['automaticReportingActive'],
    };
}

